export const LOGIN_SESSION_IN_PROGRESS = 'LOGIN_SESSION_IN_PROGRESS';
